export default __webpack_public_path__ + "static/media/SFProDisplay-Light.9166ce32.woff";